import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dHeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dAddress from "../Restaumatic.Address/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dOrder$dTypes from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dPrelude$dSpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dItems from "../Restaumatic.Site.Components.Cart.Items/index.js";
import * as Restaumatic$dSite$dComponents$dCrossSelling from "../Restaumatic.Site.Components.CrossSelling/index.js";
import * as Restaumatic$dSite$dComponents$dDeliveryMethod from "../Restaumatic.Site.Components.DeliveryMethod/index.js";
import * as Restaumatic$dSite$dComponents$dDeliveryStatus from "../Restaumatic.Site.Components.DeliveryStatus/index.js";
import * as Restaumatic$dSite$dComponents$dQrWaiter from "../Restaumatic.Site.Components.QrWaiter/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dExtra from "../Specular.Dom.Extra/index.js";
import * as Specular$dDom$dExtra$dModal from "../Specular.Dom.Extra.Modal/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import * as Utils$dURL from "../Utils.URL/index.js";
const deliveryMethodDescription = v => {
  if (v.tag === "DeliveryMethodPickup") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.description.pickup), {});
  }
  if (v.tag === "DeliveryMethodShipment") {
    if (v._1.tag === "Just") {
      return Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.description.delivery_to_address),
        {address: Restaumatic$dAddress.defaultFormatBuildingAddress(v._1._1.address)}
      );
    }
    if (v._1.tag === "Nothing") {
      return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.description.delivery), {});
    }
    $runtime.fail();
  }
  if (v.tag === "DeliveryMethodNoContactDelivery") {
    if (v._1.tag === "Just") {
      return Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.description.delivery_to_address),
        {address: Restaumatic$dAddress.defaultFormatBuildingAddress(v._1._1.address)}
      );
    }
    if (v._1.tag === "Nothing") {
      return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.description.delivery), {});
    }
    $runtime.fail();
  }
  if (v.tag === "DeliveryMethodDineIn") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.description.dine_in), {});
  }
  $runtime.fail();
};
const contentView = config => viewData => {
  const openingHourInfo = Specular$dFRP$dExtra.withUniqDynamic_({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dDom$dBuilder.monadReplaceBuilder)({
    eq: x => y => {
      if (x.tag === "Nothing") { return y.tag === "Nothing"; }
      if (x.tag === "Just") {
        if (y.tag === "Just") { return x._1 === y._1; }
        return false;
      }
      return false;
    }
  })(config.openingHour)((() => {
    const $0 = Specular$dInternal$dRIO.pureImpl();
    return v1 => {
      if (v1.tag === "Nothing") { return $0; }
      if (v1.tag === "Just") {
        const $1 = v1._1;
        return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("item")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
          Specular$dDom$dElement.class_("icon-time"),
          Specular$dDom$dElement.attr("aria-hidden")("true")
        ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.opening_hour),
          {hour: $1}
        )))))))($0);
      }
      $runtime.fail();
    };
  })());
  const errors = Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(viewData.errors)(Data$dFoldable.foldrArray(x => {
    const $0 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["alert", "alert-danger", "u-mt2", "u-mb0"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
      Specular$dDom$dElement.classes(["icon-exclamation-sign"]),
      Specular$dDom$dElement.attr("aria-hidden")("true")
    ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => {
      if (x.tag === "MinOrderValueWarning") {
        return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.errors.models.order.min_order_value),
          {
            value: Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(x._1.minValue),
            missing_value: Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(x._1.missingValue)
          }
        ));
      }
      if (x.tag === "MaxOrderValueWarning") {
        return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.errors.models.order.max_order_value),
          {value: Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(x._1.maxValue)}
        ));
      }
      if (x.tag === "UnavailableDishes") {
        const $0 = x._1.names;
        return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.unavailable),
          {}
        )))(() => Specular$dDom$dElement.el_("ul")(Data$dFoldable.foldrArray(x$1 => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$2 => x$2)(Specular$dDom$dElement.el_("li")(Specular$dDom$dElement.text(x$1))))(b))(Specular$dInternal$dRIO.pureImpl())($0)));
      }
      if (x.tag === "OrderingNotPossible") {
        return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.menu.closed_message),
          {}
        ));
      }
      if (x.tag === "NotOverlappingDishes") {
        return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.orders.form.not_overlapping_delivery_times),
          {}
        ));
      }
      $runtime.fail();
    })));
    return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)($0))(b);
  })(Specular$dInternal$dRIO.pureImpl()));
  const deliveryNotSelected = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["alert", "alert-info", "u-mb0"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.class_("icon-info-sign"),
    Specular$dDom$dElement.attr("aria-hidden")("true")
  ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.cost_info),
    {}
  ))));
  const deliveryErrors = deliveryMethod => Restaumatic$dSite$dComponents$dDeliveryStatus.deliveryStatusWidget({showLoading: false})(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dOrder$dTypes.sequenceDeliveryMethod(Data$dMaybe.applicativeMaybe))(deliveryMethod))(viewData.deliveryStatus);
  const deliveryCostInfo = Specular$dFRP$dReplaceable.whenJustD(Specular$dDom$dBuilder.monadReplaceBuilder)({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(viewData.deliveryCost)(deliveryCost => Specular$dDom$dElement.el("p")([Specular$dDom$dElement.class_("u-small-spacing-b")])(Specular$dDom$dElement.el_("span")(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
    Specular$dDom$dElement.classes(["icon-info-sign"]),
    Specular$dDom$dElement.attr("aria-hidden")("true")
  ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.delivery.cost),
    {}
  )))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(": "))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dSite$dI18n.currency)(deliveryCost)))))))));
  const deliveryAddressForm = Specular$dDom$dBuilder.local(env => (
    {
      geocoding: env.geocoding,
      storage: env.storage,
      sessionStorage: env.sessionStorage,
      forceShowValidationErrors: (() => {
        const n = Specular$dInternal$dIncremental.constant(false);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })()
    }
  ))(Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dDeliveryMethod.deliveryMethodWidget({
    country: config.restaurant.country,
    accountId: config.accountId,
    restaurantId: config.restaurant.id,
    fulfillmentMethods: config.restaurant.fulfillmentMethods,
    withAptInfo: false
  }))(deliveryMethod => Specular$dFRP$dBase.subscribeDyn_({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(viewData.setDeliveryMethod)(deliveryMethod)));
  const changeDeliveryButton = deliveryMethod => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["delivery", "item"])])(Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["delivery-info", "d-flex"])
  ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "name"])])(Specular$dDom$dElement.el("a")([
    Specular$dDom$dElement.attr("href")("#"),
    Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(v => viewData.editDelivery)
  ])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(deliveryMethodDescription)(deliveryMethod)))))(() => Specular$dDom$dElement.el("div")([
    Specular$dDom$dElement.classes(["column", "subtotal"])
  ])(Specular$dDom$dElement.el_("span")(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return ""; }
    if (v2.tag === "Just") { return Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v2._1); }
    $runtime.fail();
  })(viewData.deliveryCost)))))));
  return Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dQrWaiter.isDineInOrder(Specular$dDom$dBuilder.monadReaderBuilder)(Specular$dInternal$dRIO.monadEffectRIO))(isQrCodeOrder => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(viewData.cart)(cart => Restaumatic$dSite$dComponents$dCart$dItems.itemsView({
    restaurantId: config.restaurant.id,
    fodEnabled: Data$dRecord.unsafeGet("enableFod")(config.menu) && !isQrCodeOrder
  })(Data$dRecord.unsafeGet("enableCoupons")(config.menu) && !isQrCodeOrder)(config.themeSettings)(Data$dRecord.unsafeGet("timeZone")(config.menu))(cart)(viewData.action)(viewData.promotionsChanged)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.withUniqDynamic_({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dDom$dBuilder.monadReplaceBuilder)(Data$dEq.eqInt)(viewData.packagingContainersCost)(cost => {
    const $0 = Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("item")])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["d-flex"])])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["column", "name", "u-flex-grow"])
    ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.cart.packagingContainersCost),
      {}
    ))))(() => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.classes(["column", "subtotal"])])(Specular$dDom$dElement.text(Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(cost))))));
    if (cost !== 0) { return $0; }
    return Specular$dInternal$dRIO.pureImpl();
  }))(() => Specular$dInternal$dRIO.bindImpl(openingHourInfo)(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dTuple.Tuple)(viewData.displayDeliveryForm))(viewData.deliveryMethod))(v => {
    if (!v._1) {
      if (v._2.tag === "Just") {
        if (v._2._1.tag === "DeliveryMethodDineIn") {
          if (v._2._1._1.tag === "Just") {
            if (v._2._1._1._1.location.tag === "Just") { return Restaumatic$dPrelude$dSpecular.wempty; }
            const $0 = v._2._1;
            return changeDeliveryButton((() => {
              const n = Specular$dInternal$dIncremental.constant($0);
              Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
              return n;
            })());
          }
          const $0 = v._2._1;
          return changeDeliveryButton((() => {
            const n = Specular$dInternal$dIncremental.constant($0);
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })());
        }
        const $0 = v._2._1;
        return changeDeliveryButton((() => {
          const n = Specular$dInternal$dIncremental.constant($0);
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        })());
      }
      return Restaumatic$dPrelude$dSpecular.wempty;
    }
    return Restaumatic$dPrelude$dSpecular.wempty;
  }))(() => {
    const shouldDisplay = viewData.displayDeliveryForm;
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("form")([
      Specular$dDom$dElement.classes(["delivery", "item", "is-editing"]),
      Specular$dDom$dElement.attrUnlessD(shouldDisplay)("style")("display: none;")
    ])(Specular$dInternal$dRIO.bindImpl(deliveryAddressForm)(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.unlessD({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dDom$dBuilder.monadReplaceBuilder)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.isNothing)(viewData.deliveryMethod))(deliveryCostInfo))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.whenJustD(Specular$dDom$dBuilder.monadReplaceBuilder)({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(viewData.deliveryMethod)(deliveryErrors))(() => errors)))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.unlessD({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dDom$dBuilder.monadReplaceBuilder)(shouldDisplay)(Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dReplaceable.whenJustD(Specular$dDom$dBuilder.monadReplaceBuilder)({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(viewData.deliveryMethod)(deliveryErrors))(() => errors)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dExtra.whenD({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dDom$dBuilder.monadReplaceBuilder)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.isNothing)(viewData.deliveryMethod))(deliveryNotSelected))(() => {
      const $0 = Restaumatic$dSite$dComponents$dCrossSelling.display()()({field: viewData.crossSelling});
      return env => $0({parent: env.parent, cleanup: env.cleanup, userEnv: undefined});
    })));
  })))));
};
const view = config => viewData => {
  const cartTitle = Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("h4")([Specular$dDom$dElement.class_("modal-title"), Specular$dDom$dElement.attr("id")("cart-title")])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.name),
    {}
  ))))(() => Specular$dDom$dElement.text(" "));
  return Specular$dProfiling.measure(Specular$dInternal$dRIO.monadEffectRIO)("Cart.view")((() => {
    const $0 = Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-header")])(Specular$dInternal$dRIO.bindImpl((() => {
      const $0 = viewData.closeCart;
      return Specular$dDom$dElement.el("a")([
        Specular$dDom$dElement.class_("close-cart"),
        Specular$dDom$dElement.attr("href")("#"),
        Specular$dDom$dElement.attr("data-ga-action")("Close cart (X button clicks)"),
        Specular$dDom$dElement.attr("title")(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.hide_and_continue),
          {}
        )),
        Specular$dDom$dElement.attr("data-testid")("cart/closeCart"),
        Specular$dDom$dElement.onClick(x => {
          const $1 = Specular$dDom$dBrowser.preventDefault(x);
          return () => {
            $0();
            $1();
          };
        })
      ])(Specular$dDom$dElement.text("×"));
    })())(() => Specular$dInternal$dRIO.bindImpl(cartTitle)(() => {
      const $0 = viewData.clearCart;
      const $1 = Specular$dDom$dExtra.visibleIfDyn(viewData.canClearCart)(Specular$dDom$dElement.el("a")([
        Specular$dDom$dElement.attr("href")("#"),
        Specular$dDom$dElement.class_("clear-cart"),
        Specular$dDom$dElement.onClick(x => {
          const $1 = Specular$dDom$dBrowser.preventDefault(x);
          return () => {
            $0();
            $1();
          };
        })
      ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.clear),
        {}
      ))));
      return env => $1({parent: env.parent, cleanup: env.cleanup, userEnv: undefined});
    }))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-body")])(contentView(config)(viewData)))(() => Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.classes(["modal-footer", "modal-footer--sticky"])
    ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-footer__actions")])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.classes(["btn", "btn-default", "continue-shopping"]),
      Specular$dDom$dElement.classWhenD(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dHeytingAlgebra.boolConj)(Specular$dFRP$dBase.functorDynamic.map(Data$dFoldable.foldrArray(v => v1 => false)(true))(viewData.errors)))(viewData.canClearCart))("hidden-xs"),
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.attr("data-ga-action")("Close cart (continue shopping clicks)"),
      Specular$dDom$dElement.attr("data-testid")("cart/continueShopping"),
      Specular$dDom$dElement.onClick_(viewData.closeCart)
    ])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.hide),
      {}
    ))))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.el("button")([
      Specular$dDom$dElement.classes(["btn", "checkout", "btn-checkout"]),
      Specular$dDom$dElement.attr("type")("button"),
      Specular$dDom$dElement.attrUnlessD(viewData.canOrder)("disabled")("disabled"),
      Specular$dDom$dElement.onClick_(viewData.submit),
      Specular$dDom$dElement.attr("data-testid")("Cart/submit")
    ])(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(total => Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.checkout),
      {}
    ) + " " + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(total))(viewData.grandTotal)))(() => Specular$dDom$dElement.el("i")([
      Specular$dDom$dElement.class_("icon-chevron-right")
    ])(Restaumatic$dPrelude$dSpecular.wempty)))))))));
    const mCartModalImage = (() => {
      if (config.themeSettings.cartModalImage.tag === "Just") {
        if (config.themeSettings.cartModalImage._1 === "") { return Data$dMaybe.Nothing; }
        return Data$dMaybe.$Maybe("Just", config.themeSettings.cartModalImage._1);
      }
      if (config.themeSettings.cartModalImage.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el$p("div")([
      Specular$dDom$dElement.classes(["modal", "fade", "cart", "cart--modal", "js-popover-container"]),
      Specular$dDom$dElement.attr("aria-labelledby")("cart-title"),
      Specular$dDom$dElement.attr("id")("cart"),
      Specular$dDom$dElement.attr("role")("dialog"),
      Specular$dDom$dElement.attr("tabindex")("-1")
    ])(Specular$dDom$dElement.el("div")([
      Specular$dDom$dElement.class_("modal-dialog"),
      (() => {
        if (mCartModalImage.tag === "Nothing") { return false; }
        if (mCartModalImage.tag === "Just") { return true; }
        $runtime.fail();
      })()
        ? Specular$dDom$dElement.class_("modal-dialog--with-image")
        : Specular$dDom$dElement.monoidProp.mempty,
      Specular$dDom$dElement.attr("role")("document")
    ])(Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("modal-content")])(Specular$dInternal$dRIO.bindImpl((() => {
      if (mCartModalImage.tag === "Just") {
        const $1 = Utils$dURL.imgixUrl + Utils$dURL.adjustImage({w: "159", h: "768", crop: true})(mCartModalImage._1);
        return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dDom$dElement.el_("picture")(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("source")([
          Specular$dDom$dElement.attr("srcset")("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
          Specular$dDom$dElement.attr("media")("(max-width: 479px)")
        ])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dDom$dElement.el("img")([
          Specular$dDom$dElement.class_("modal-dialog__image"),
          Specular$dDom$dElement.attr("src")($1),
          Specular$dDom$dElement.attr("alt")("")
        ])(Restaumatic$dPrelude$dSpecular.wempty)))))(Specular$dInternal$dRIO.pureImpl());
      }
      return Specular$dInternal$dRIO.pureImpl();
    })())(() => $0)))))(v => {
      const $1 = Specular$dDom$dExtra$dModal.controlModal(v._1)(viewData.modalAction);
      return env => $1({parent: env.parent, cleanup: env.cleanup, userEnv: undefined});
    });
  })());
};
export {contentView, deliveryMethodDescription, view};
